import { BrowserRouter, Routes, Route, Navigate, NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLightbulb, faPlusCircle, faSearch } from '@fortawesome/free-solid-svg-icons';
import NewRequest from './pages/NewRequest/NewRequest';
import TrackRequest from './pages/TrackRequest/TrackRequest';
import PrivacyPolicy from './pages/PrivacyPolicy/PrivacyPolicy';

export default function App() {
  return (
    <BrowserRouter>
      <header className="public-header">
        <div className="header-inner">
          <div className="header-top">
            <img src="/prefeitura.png" alt="Brasão da Prefeitura Municipal de Pesqueira" className="header-logo" />
            <h1>Iluminação Pública</h1>
          </div>
          <p className="header-subtitle">Prefeitura Municipal de Pesqueira — PE</p>
          <nav className="header-nav">
            <NavLink to="/nova-solicitacao" className={({ isActive }) => isActive ? 'active' : ''}>
              <FontAwesomeIcon icon={faPlusCircle} />
              Nova solicitação
            </NavLink>
            <NavLink to="/consultar" className={({ isActive }) => isActive ? 'active' : ''}>
              <FontAwesomeIcon icon={faSearch} />
              Consultar protocolo
            </NavLink>
          </nav>
        </div>
      </header>
      <main className="container">
        <Routes>
          <Route path="/nova-solicitacao" element={<NewRequest />} />
          <Route path="/consultar" element={<TrackRequest />} />
          <Route path="/privacidade" element={<PrivacyPolicy />} />
          <Route path="*" element={<Navigate to="/nova-solicitacao" replace />} />
        </Routes>
      </main>
      <footer className="public-footer">
        <div>
          <FontAwesomeIcon icon={faLightbulb} className="footer-icon" />
          Secretaria de Serviços Públicos — Pesqueira (PE)
          <FontAwesomeIcon icon={faLightbulb} className="footer-icon" />
        </div>
        <p className="footer-org">Prefeitura Municipal de Pesqueira (PE)</p>
      </footer>
    </BrowserRouter>
  );
}
